'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ToggleLoading } from './loading';
import { Skeleton } from './skeleton';
import './skeleton-loading.css';
/**
 * SkeletonLoading — Accessible skeleton page used while content or data is loading.
 *
 * @param {number} [props.heroHeight] - Height in pixels for the hero skeleton block.
 * @param {number} [props.cardCount] - Number of placeholder cards to render in the cards section.
 * @param {string} [props.className] - Optional additional CSS classes applied to the root element.
 */
SkeletonLoading.propTypes = {
    /** Hero skeleton height (px) */
    heroHeight: PropTypes.number,
    /** Number of placeholder cards to render */
    cardCount: PropTypes.number,
    /** Extra CSS classes for the root element */
    className: PropTypes.string,
};
export function SkeletonLoading({ heroHeight = 220, cardCount = 6, className = '' }) {
    useEffect(() => {
        // Keep the app-level ToggleLoading behavior for global spinner consumers
        try {
            ToggleLoading({ show: true });
        }
        catch (e) {
            // defensive: ToggleLoading is best-effort
        }
    }, []);
    const count = Math.max(0, Number(cardCount || 0));
    return (_jsx("main", { className: `loading-page ${className}`, children: _jsxs("div", { className: "loading-container", children: [_jsx("div", { className: "visually-hidden", role: "status", "aria-live": "polite", children: "Loading\u2026" }), _jsx("section", { id: "hero-loading", "aria-hidden": true, className: "hero-loading", children: _jsx(Skeleton, { variant: "rect", height: heroHeight }) }), _jsx("section", { id: "cards-loading", className: "cards-loading", "aria-hidden": true, children: Array.from({ length: count }).map((_, i) => (_jsx("article", { className: "card-article", children: _jsxs("div", { className: "card-row", children: [_jsx(Skeleton, { variant: "avatar" }), _jsxs("div", { className: "card-body", children: [_jsx(Skeleton, { lines: 2 }), _jsx("div", { className: "card-body-extra", children: _jsx(Skeleton, { lines: 3, width: "90%" }) })] })] }) }, i))) })] }) }));
}
